import * as React from "react";
import { forwardRef } from "react";
const SvgIconPlusThick = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 6.002, height: 6, viewBox: "0 0 6.002 6", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3940.572 10821v-2.572H3938v-.856h2.573V10815h.857v2.57h2.57v.856h-2.573v2.574z", "data-name": "Union 194", transform: "translate(-3937.999 -10815)", fill: "#98a9bc" }));
const ForwardRef = forwardRef(SvgIconPlusThick);
export { ForwardRef as ReactComponent };
